import { setallCategories, setallCollectionList } from "../store/slices/all-category-slice";
import { setCategoryProducts } from "../store/slices/categoryProduct-slice";
import { store } from "../store/store";
export const fetchCategories = async (setCategories) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HTTPS_URL}/categories?limit=100&page=1&status=1`,
        {
          method: "GET",
          headers: {
            "Client-Id": process.env.REACT_APP_CLIENT_ID,
          },
        }
      );
  
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
  
      const result = await response.json();
      // Update the state with extracted categories
      if(setCategories)
      {
        setCategories(result.data.map((item) => item.category));
      }
      store.dispatch(setallCategories(result.data.map((item) => item.category)))
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  export const fetchCollectionList = async (setcollectionList) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HTTPS_URL}/collections`,
        {
          method: "GET",
          headers: {
            "Client-Id": process.env.REACT_APP_CLIENT_ID,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
     if (setcollectionList) {
      if (Array.isArray(result)) {
        setcollectionList(result);
      } else {
        setcollectionList([]);
      }
    }
    if (Array.isArray(result)) {
      store.dispatch(setallCollectionList(result));
    } else {
      store.dispatch(setallCollectionList([]));
    }
    } catch (error) {
      console.error("Error fetching categories:", error);
      if (setcollectionList) {
        setcollectionList([]);
      }
    }
  };


  export const fetchCategoryProducts = async (category) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HTTPS_URL}/products-filter?limit=400&page=0&status=1`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Client-Id": process.env.REACT_APP_CLIENT_ID,
          },
          body: JSON.stringify({ categories: [`${category}`] }),
        }
      );
  
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
  
      const result = await response.json();
      const products = result;
  
      // Dispatch action to store the products in Redux
      store.dispatch(setCategoryProducts(products));
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };